var map = {
	"./stream-type-combained-ico.svg": 82037,
	"./stream-type-ipcam-ico.svg": 30419,
	"./stream-type-live-ico.svg": 98699,
	"./stream-type-restream-ico.svg": 96338,
	"./stream-type-scheduled-ico.svg": 26418,
	"./stream-type-subsecond-ico.svg": 11413,
	"./stream-type-transcoder-ico.svg": 43160,
	"./stream-type-tvplayout-ico.svg": 78795,
	"./stream-type-vod-ico.svg": 70096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36729;